module.exports = __webpack_public_path__ + "static/media/welcome-image.e527806c.png";